<template>
  <div class="detail-pop" :style="{ width: popWidth, height: popHeight }">
    <div class="detail-pop-header">
      <div class="detail-pop-header-title">{{ title }}</div>
      <div class="detail-pop-header-close" @click="onClose">
        <i class="iconfont icon-guanbi2"></i>
      </div>
    </div>
    <div class="detail-pop-center">
      <div class="detail-pop-content">
        <!-- <div class="detail-pop-content-title">批准范围</div> -->
        <div class="detail-pop-content-box">
          <el-row :gutter="20">
            <el-col :span="12" class="detail-pop-content-box-col">
              <el-col :span="8">联系人员：</el-col>
              <el-col :span="16"> {{ info.person }}</el-col>
            </el-col>
            <el-col :span="12" class="detail-pop-content-box-col">
              <el-col :span="8">联系电话</el-col>
              <el-col :span="16">{{ info.phone }}</el-col>
            </el-col>
            <el-col :span="24" class="detail-pop-content-box-col">
              <el-col :span="4">招商政策:</el-col>
              <el-col :span="20">{{ info.investmentPolicy }}</el-col>
            </el-col>
            <el-col :span="24" class="detail-pop-content-box-col">
              <el-col :span="4">项目情况:</el-col>
              <el-col :span="20">{{ info.projectSituation }}</el-col>
            </el-col>
            <el-col :span="24" class="detail-pop-content-box-col">
              <el-col :span="4">招商需求:</el-col>
              <el-col :span="20">{{ info.investmentDemand }}</el-col>
            </el-col>
            <el-col :span="24" class="detail-pop-content-box-col">
              <el-col :span="4">产业链:</el-col>
              <el-col :span="20">{{ info.industrialChain }}</el-col>
            </el-col>
            <el-col :span="24" class="detail-pop-content-box-col">
              <el-col :span="4">人才情况:</el-col>
              <el-col :span="20">{{ info.talentSituation }}</el-col>
            </el-col>
            <el-col :span="24" class="detail-pop-content-box-col">
              <el-col :span="4">用地情况:</el-col>
              <el-col :span="20">{{ info.landSituation }}</el-col>
            </el-col>
            <el-col :span="24" class="detail-pop-content-box-col">
              <el-col :span="4">宣传图片</el-col>
              <el-col :span="20">
                <!-- <preview-image :imgList="info.pronounceImages"></preview-image> -->
                <!--  @click="handleLook(item)" -->
                <div class="img-list-box" v-viewer="{ movable: true }">
                  <div
                    class="img-list"
                    v-for="(item, index) in info.pronounceImages"
                    :key="index"
                  >
                    <img :src="item.url" alt="" />
                    <el-tooltip
                      class="item"
                      effect="dark"
                      :content="item.fileTitle"
                      placement="top-start"
                    >
                      <div class="img-span">{{ item.fileTitle }}</div>
                    </el-tooltip>
                  </div>
                </div>
              </el-col>
            </el-col>
            <el-col :span="24" class="detail-pop-content-box-col">
              <el-col :span="4">相关附件:</el-col>
              <el-col :span="20">
                <div
                  class="file-list-box"
                  v-for="(item, index) in info.attachmentFiles"
                  :key="index"
                  v-show="info.attachmentFiles.length > 0"
                >
                  <div class="list-li">
                    <div class="mouse-s">
                      <i class="iconfont icon-geshi_shipinmp"></i>
                      {{ item.fileTitle }}
                    </div>
                    <div @click="lookPdf(item)">
                      查看/下载
                      <!-- <i
                        class="el-icon-view mouse-s"
                        style="padding-right: 10px; color: #560aeb"
                        
                      ></i> -->
                    </div>
                  </div>
                </div>
              </el-col>
            </el-col>
            <el-col :span="24" class="detail-pop-content-box-col">
              <el-col :span="4">宣传视频:</el-col>
              <el-col :span="20">
                <div class="img-list-box">
                  <div
                    class="img-list1"
                    v-for="(item, index) in info.pronounceVideos"
                    :key="index"
                  >
                    <img :src="item.thumbnailSrc" alt="" />
                    <div class="mask">
                      <div
                        class="iconfont icon-bofang"
                        @click="playVideos(item)"
                      ></div>
                    </div>
                    <el-tooltip
                      class="item"
                      effect="dark"
                      :content="item.fileTitle"
                      placement="top-start"
                    >
                      <div class="img-span">{{ item.fileTitle }}</div>
                    </el-tooltip>
                  </div>
                </div>
              </el-col>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
    <video-image
      :visible="dialogVisible"
      :imageSrc="dialogImageUrl"
      @onCloseImage="onCloseImage"
    ></video-image>
    <video-dialog
      :visible="dialogVisibleVideo"
      :videoSrc="videoSrc"
      :videoTitle="videoTitle"
      @onCloseVideo="onCloseVideo"
    ></video-dialog>
  </div>
</template>
<script>
import VideoDialog from "@/components/currency/videoDialog";
import VideoImage from "@/components/currency/videoImage";
import PreviewImage from "@/components/currency/previewImage";
import "@/assets/css/common.css";
export default {
  name: "investment-detail-pop",
  components: {
    VideoDialog,
    VideoImage,
    PreviewImage,
  },
  props: {
    title: {
      type: String,
      default: "标题",
    },
    popHeight: {
      type: String,
      default: "600px",
    },
    popWidth: {
      type: String,
      default: "600px",
    },
    colProportion: {
      type: Number,
      default: 12,
    },
    labelProportion: {
      type: Number,
      default: 6,
    },
    valueProportion: {
      type: Number,
      default: 18,
    },
    info: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },

  data() {
    return {
      imgList: [],
      dialogVisibleVideo: false,
      videoSrc: "",
      videoTitle: "",
      dialogImageUrl: "",
      dialogVisible: false,
    };
  },
  watch: {
    info: {
      handler: function (data) {
        if (data.attachmentFiles && data.attachmentFiles.length > 0) {
          let list = data.attachmentFiles;
          for (let i in list) {
            this.imgList.push(
              systemConfig.imgServer + systemConfig.imgApi + list[i].filePath
            );
          }
        } else {
          this.imgList = [];
        }
      },
      deep: true,
    },
  },
  mounted() {},
  methods: {
    onClose() {
      this.$emit("onCloseInvestment", false);
    },
    //播放视频
    playVideos(file) {
      this.dialogVisibleVideo = true;
      this.videoSrc =
        systemConfig.imgServer + systemConfig.imgApi + file.filePath;
      this.videoTitle = file.fileTitle || "";
    },
    onCloseVideo() {
      this.dialogVisibleVideo = false;
    },
    onCloseImage() {
      this.dialogVisible = false;
    },
    lookPdf(file) {
      window.open(systemConfig.imgServer + systemConfig.imgApi + file.filePath);
    },
    //查看图片
    handleLook(file) {
      this.dialogVisible = true;
      this.dialogImageUrl = file.url;
    },
  },
};
</script>
<style scoped>
.list-li {
  margin-left: 0;
}

.file-list-box {
  padding-left: 0;
}
.mouse-s {
  color: #fff;
}
.detail-pop {
  background: rgba(18, 86, 112, 0.8);
  border: 1px solid #05f6fa;
  border-image: linear-gradient(#2a7b95, #2bffff) 40 40;
}
.detail-pop-header {
  color: #fff;
  font-size: 1.12rem;
  padding: 7px 29px;
  display: flex;
  position: relative;
  justify-content: space-between;
}
.detail-pop-header-title {
  font-weight: bolder !important;
  background: linear-gradient(to bottom, #ffffff, #28ffff);
  -webkit-background-clip: text;
  color: transparent;
}
.detail-pop-header-close {
  position: absolute;
  top: 0;
  right: 0;
  width: 26px;
  height: 26px;
  background: rgb(89 197 222 / 62%);
  border-radius: 0 0 0 50px;
  text-align: center;
  color: #014f52;
  font-weight: 600;
  cursor: pointer;
}
.detail-pop-center {
  height: calc(100% - 44px);
  overflow: auto;
}
.detail-pop-content {
  margin: 6px 15px;
  color: #fff;
}
.detail-pop-content-title {
  padding: 2px 15px;
  background: #185c75;
  font-size: 0.85rem;
  font-weight: 600;
  margin-bottom: 7px;
}
.detail-pop-content-box {
  font-size: 0.85rem;
}
.detail-pop-content-box-col {
  padding: 6px 0;
  word-break: break-all;
}

.file-title {
  font-size: 0.85rem;
  padding: 5px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.img-list {
  width: 65px;
  height: 85px;
  margin-right: 10px;
}
.img-list1 {
  position: relative;
  width: 65px;
  height: 85px;
  margin-right: 10px;
}
.img-list1:hover .mask {
  opacity: 1;
  cursor: default;
}
.img-list1 > img {
  width: 100%;
  height: 65px;
  border-radius: 4px;
  overflow: hidden;
}
.mask {
  width: 65px;
  height: 65px;
  font-size: 0.95rem;
  display: flex;
  justify-content: space-around;
  position: absolute;
  top: 0;
  opacity: 0;
  background: rgba(4, 20, 41, 0.4);
  border-radius: 4px;
  padding: 24px 0;
}
.img-span {
  font-size: 0.75rem;
  width: 100%;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.img-list > img {
  width: 100%;
  height: 65px;
  border-radius: 4px;
  overflow: hidden;
}
.img-list-box {
  display: flex;
  flex-wrap: wrap;
}
</style>
